/**
 * THIS COMPONENT IS DEPRECATED
 * USE "components/Calendar/CalendarDropdown" INSTEAD
 */

import * as React from "react";
import moment from "moment";
import { SingleDatePicker } from "react-dates";
import BaseFormElement, { FieldProps } from "components/Form/BaseFormElement";
import styles from "./styles.scss";
import SearchableSelect from "../LegacySearchable/SearchableSelect";
import cx from "classnames";

const setIdAndName = (v: number | string) => ({ id: v, name: v });
const currentYear = moment().year();
const YEARS = Array.from({ length: currentYear + 1 - (currentYear - 100) }, (_, i) => currentYear - 99 + i)
  .map(setIdAndName)
  .reverse();
const MONTHS = moment.monthsShort().map(setIdAndName);

export interface DatePickerProps extends FieldProps {
  id: string;
  onChange?: (m: moment.Moment | null) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  isOutsideRange?: (m: moment.Moment) => boolean;
  direction?: "up" | "down";
  value: moment.Moment | null;
  placeholder?: string;
  testId?: string;
  className?: string;
}

interface State {
  focused: boolean;
}

/**
 * @deprecated
 */
export default class DatePicker extends React.Component<DatePickerProps, State> {
  readonly state: State = {
    focused: false,
  };

  public static defaultProps = {
    direction: "down",
  };

  public componentDidUpdate(_: {}, { focused: wasFocused }: State) {
    const { focused } = this.state;

    if (wasFocused && !focused) {
      if (this.props.onBlur) this.props.onBlur();
    } else if (!wasFocused && focused) {
      if (this.props.onFocus) this.props.onFocus();
    }
  }

  private renderMonthElement = ({ month, onMonthSelect, onYearSelect }: any) => {
    return (
      <div className={styles.monthYearContainer}>
        <SearchableSelect
          selectedItem={month.format("MMM")}
          compact
          name={null}
          onChange={e => onMonthSelect(month, e.name)}
          placeholder={"Mon"}
          items={MONTHS}
          wrapperClassName={styles.searchableWrapper}
          inputClassName={styles.customInput}
        />

        <SearchableSelect
          selectedItem={month.year()}
          onChange={e => onYearSelect(month, e.name)}
          name={null}
          compact
          placeholder={"Year"}
          items={YEARS}
          wrapperClassName={styles.searchableWrapper}
          inputClassName={styles.customInput}
        />
      </div>
    );
  };

  public render() {
    const {
      id,
      onChange,
      value,
      disabled,
      placeholder,
      direction,
      isOutsideRange,
      testId,
      className,
      ...fieldProps
    } = this.props;
    const { focused } = this.state;

    return (
      <BaseFormElement
        arrow={focused ? "up" : "down"}
        disabled={disabled}
        className={cx(focused ? styles.focusedDatePicker : styles.datePicker, className)}
        inputClassNameProp={null}
        {...fieldProps}
        testId={testId}
      >
        <SingleDatePicker
          id={id}
          numberOfMonths={1}
          disabled={disabled}
          isOutsideRange={isOutsideRange}
          date={value ? moment(value) : null}
          onDateChange={date => date && onChange && onChange(date)}
          onFocusChange={({ focused }) => this.setState({ focused: !!focused })}
          hideKeyboardShortcutsPanel={true}
          placeholder={placeholder}
          openDirection={direction}
          focused={focused}
          renderMonthElement={this.renderMonthElement}
        />
      </BaseFormElement>
    );
  }
}
